import NativeAccountPage from './NativeAccountPage';

export default function SignupForm() {
  return (
    <NativeAccountPage
      title="Create Your Account"
      description="Continue to set up your account and team, review the terms and verify your email."
      label="Continue Account Setup"
      returnHref="/accounts/login/"
      returnLabel="Sign In"
      href="/accounts/signup/"
    />
  );
}
